var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-success-container" },
    [
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("div", { staticClass: "t1" }, [
            _c(
              "svg",
              {
                staticStyle: { "vertical-align": "middle" },
                attrs: {
                  t: "1574154963539",
                  viewBox: "0 0 1024 1024",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "p-id": "3670",
                  width: "24",
                  height: "24"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M0 512C0 229.235 229.235 0 512 0s512 229.235 512 512-229.235 512-512 512S0 794.765 0 512z m419.31 194.63a35.31 35.31 0 0 0 49.4 1.272L804.228 395.97a35.31 35.31 0 0 0-48.075-51.73L447.03 633.786 301.903 484.14a35.31 35.31 0 1 0-50.688 49.17l168.113 173.32z",
                    "p-id": "3671",
                    fill: "#005924"
                  }
                })
              ]
            ),
            _c(
              "span",
              {
                staticClass: "tips-larger",
                staticStyle: {
                  "vertical-align": "middle",
                  "margin-left": "10px"
                }
              },
              [_vm._v(_vm._s(_vm.$t("result.success")))]
            )
          ]),
          _c("div", { staticClass: "t1" }, [
            _c("span", { staticStyle: { "vertical-align": "middle" } }, [
              _c("span", { staticStyle: { "vertical-align": "middle" } }, [
                _vm._v(_vm._s(_vm.$t("result.paymoney"))),
                _c(
                  "span",
                  { staticStyle: { color: "red", "font-weight": "bolder" } },
                  [_vm._v(_vm._s(_vm.order.orderMoney))]
                ),
                _vm._v(_vm._s(_vm.$t("result.yuan")) + "!")
              ])
            ])
          ]),
          _c("pay-detail", { attrs: { item: _vm.payInfo } }),
          _c("pay-detail", { attrs: { item: _vm.orderDetail } }),
          _c("pay-detail", { attrs: { item: _vm.ticketInfo } }),
          _c(
            "div",
            {
              staticClass: "t1",
              staticStyle: { margin: "0vh 4vw", "text-align": "center" }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showTicketTips,
                      expression: "showTicketTips"
                    }
                  ],
                  staticStyle: { "vertical-align": "middle", color: "red" }
                },
                [_vm._v("请过15分钟后前往“交费情况”查看电子票。")]
              )
            ]
          )
        ],
        1
      ),
      _c("pre-page", { attrs: { title: "返 回" }, on: { back: _vm.close } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }